const site = (state = {}, action = {}) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default site;
